var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9974 36.1459C26.8729 36.1459 28.3932 34.6255 28.3932 32.75C28.3932 30.8746 26.8729 29.3542 24.9974 29.3542C23.1219 29.3542 21.6016 30.8746 21.6016 32.75C21.6016 34.6255 23.1219 36.1459 24.9974 36.1459Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0807 19.8542V17.25C38.0807 11.625 36.7266 4.16669 24.9974 4.16669C13.2682 4.16669 11.9141 11.625 11.9141 17.25V19.8542C6.08073 20.5834 4.16406 23.5417 4.16406 30.8125V34.6875C4.16406 43.2292 6.76823 45.8334 15.3099 45.8334H34.6849C43.2266 45.8334 45.8307 43.2292 45.8307 34.6875V30.8125C45.8307 23.5417 43.9141 20.5834 38.0807 19.8542ZM24.9974 39.0417C21.5182 39.0417 18.7057 36.2084 18.7057 32.75C18.7057 29.2709 21.5391 26.4584 24.9974 26.4584C28.4557 26.4584 31.2891 29.2917 31.2891 32.75C31.2891 36.2292 28.4766 39.0417 24.9974 39.0417ZM15.3099 19.6667C15.1432 19.6667 14.9974 19.6667 14.8307 19.6667V17.25C14.8307 11.1459 16.5599 7.08335 24.9974 7.08335C33.4349 7.08335 35.1641 11.1459 35.1641 17.25V19.6875C34.9974 19.6875 34.8516 19.6875 34.6849 19.6875H15.3099V19.6667Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketClose);
export default __webpack_public_path__ + "static/media/ticket-close.dd57122d70d82e2beabc9ea6ecbac8f6.svg";
export { ForwardRef as ReactComponent };